import {
  getHierarchyPumps,
  postHierarchyPump,
  putHierarchyPump,
} from '../../../Api/services/backoffice';

export const key = 'hierarchyPump';

const entityName = {
  singular: 'Alçada de Aprovação de Bombas',
  plural: 'Alçadas de Aprovação de Bombas',
};

const queries = {
  list: { key, fn: getHierarchyPumps },
  detail: { key },
};

const mutations = {
  create: postHierarchyPump,
  update: putHierarchyPump,
};

const fields = {
  table: [
    { key: 'approvalAuthority.approver', label: 'Hierarquia' },
    { key: 'rule', label: 'Regra' },
    { key: 'discount', label: 'Desconto' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
